module.exports = __webpack_public_path__ + "img/1.44b3e1a0.jpg";